{ Jadelet, Modal } from @danielx/dui

OptionTemplate := Jadelet.exec """
  option(@value) @text
"""

resolutionOptions :=
  HD: [1280, 720]
  "Full HD": [1920, 1080]
  "#Shorts": [720, 1280]
  "Ultra Wide HD": [2560, 1080]
  "WQHD": [2560, 1440]
  "4k": [3840, 2160]

optionElements := ->
  Object.keys(resolutionOptions).map (name) ->
    [w, h] := resolutionOptions[name]

    OptionTemplate
      text: `${name} (${w}x${h})`
      value: name

Template := Jadelet.exec """
form.render
  h2 Render

  label
    h3 Resolution
    select(name="resolution" value="Full HD")
      @optionElements

  label
    h3 Frame Rate (frames/second)
    select(name="fps" value="60")
      option(value="30") 30
      option(value="60") 60

  label
    h3 Start Time (seconds)
    input(name="startTime" value=0)

  label
    h3 Duration (seconds)
    input(name="duration" value=@endTime type="number" step="0.1")

  label
    h3 2x Upscale
    input(name="upscale" type="checkbox" value="1")

  actions
    button Render
    button(click=@cancel) Cancel
"""

export RenderModal := (player) ->

  Object.assign player,
    showRenderForm: ->
      // Frames go to ffmpeg through the desktop app's main process (renderer.civet)
      unless global.ELECTRON_VERSION
        Modal.alert "Rendering to .mp4 needs the desktop app."
        return

      Modal.form Template
        endTime: Math.ceil player.song.secondsLength()
        optionElements: optionElements
        cancel: (e: Event) ->
          e?.preventDefault()
          Modal.hide()
      .then (r) ->

        if r
          {resolution, fps, name, startTime, duration, upscale} := r

          res := resolutionOptions[resolution]

          let width, height

          if res
            [width, height] = res
          else
            width = 1280
            height = 720

          player.renderVideo
            height: height
            width: width
            fps: fps
            startTime: parseFloat(startTime)
            duration: parseFloat(duration)
            upscale: !!upscale

  return player

export default RenderModal
